import { Grid, MenuItem, TextField, Typography } from "@mui/material";
import { useAuthUser } from "react-auth-kit";
import { useGetPatients } from "../../PatientComponents";
import { useGetOrganizations } from "../../HandlingComponents";

function AssociationRow({ label, children }) {
  return (
    <Grid container sx={{ alignItems: "center" }}>
      <Grid item xs={6}>
        <Typography>
          <strong>{label}</strong>
        </Typography>
      </Grid>
      <Grid item xs={6}>
        {children}
      </Grid>
    </Grid>
  );
}

function KitAssociationFields({
  orgId,
  patientId,
  editMode,
  canEditOrg,
  onFieldsChange,
}) {
  const authUser = useAuthUser();
  const patientsQuery = useGetPatients();
  const organizationsQuery = useGetOrganizations();

  const patients = patientsQuery.data?.patients ?? [];
  const organizations = organizationsQuery.data?.organizations ?? [];

  const effectiveOrgId =
    authUser()?.role === 1
      ? orgId === "" || orgId == null
        ? null
        : Number(orgId)
      : authUser()?.user?.org_id ?? (orgId != null ? Number(orgId) : null);

  const filteredPatients = effectiveOrgId
    ? patients.filter((p) => Number(p.org_id) === effectiveOrgId)
    : [];

  const orgLabel =
    organizations.find((o) => Number(o.id) === Number(orgId))?.name ?? "—";
  const patient = patients.find((p) => Number(p.id) === Number(patientId));
  const patientLabel = patient
    ? `${patient.first_name} ${patient.last_name}`
    : "—";

  const handleOrgChange = (event) => {
    const newOrgId =
      event.target.value === "" ? null : Number(event.target.value);
    const patch = { org_id: newOrgId };

    if (patientId != null && patientId !== "") {
      const p = patients.find((el) => Number(el.id) === Number(patientId));
      if (p && Number(p.org_id) !== newOrgId) {
        patch.patient_id = null;
      }
    }
    onFieldsChange(patch);
  };

  const handlePatientChange = (event) => {
    const newPatientId =
      event.target.value === "" ? null : Number(event.target.value);
    const patch = { patient_id: newPatientId };

    if (canEditOrg && newPatientId != null) {
      const p = patients.find((el) => Number(el.id) === newPatientId);
      if (p?.org_id != null) {
        patch.org_id = p.org_id;
      }
    }
    onFieldsChange(patch);
  };

  if (!editMode) {
    return (
      <>
        {canEditOrg && (
          <AssociationRow label="Organizzazione (*):">
            <Typography>{orgLabel}</Typography>
          </AssociationRow>
        )}
        <AssociationRow label="Paziente:">
          <Typography>{patientLabel}</Typography>
        </AssociationRow>
      </>
    );
  }

  return (
    <>
      {canEditOrg && organizationsQuery.isSuccess && (
        <AssociationRow label="Organizzazione (*):">
          <TextField
            select
            fullWidth
            margin="dense"
            variant="standard"
            value={orgId ?? ""}
            onChange={handleOrgChange}
          >
            <MenuItem value="">
              <em>Seleziona organizzazione</em>
            </MenuItem>
            {organizations.map((org) => (
              <MenuItem key={org.id} value={org.id}>
                {org.name}
              </MenuItem>
            ))}
          </TextField>
        </AssociationRow>
      )}

      {patientsQuery.isSuccess && (
        <AssociationRow label="Paziente:">
          <TextField
            select
            fullWidth
            margin="dense"
            variant="standard"
            value={patientId ?? ""}
            onChange={handlePatientChange}
            disabled={!canEditOrg && effectiveOrgId == null}
          >
            <MenuItem value="">
              <em>Nessun paziente</em>
            </MenuItem>
            {filteredPatients.map((p) => (
              <MenuItem key={p.id} value={p.id}>
                {`${p.first_name} ${p.last_name}`}
              </MenuItem>
            ))}
          </TextField>
        </AssociationRow>
      )}
    </>
  );
}

export default KitAssociationFields;
